export interface RouteState {
  page: "directory" | "detail" | "vulnerabilities" | "not-found";
  params: Record<string, string>;
}

type RouteListener = (state: RouteState) => void;

const routes: Array<{ pattern: URLPattern; page: RouteState["page"] }> = [
  { pattern: new URLPattern({ pathname: "/" }), page: "directory" },
  { pattern: new URLPattern({ pathname: "/vulnerabilities" }), page: "vulnerabilities" },
  { pattern: new URLPattern({ pathname: "/image/:name" }), page: "detail" },
];

let listener: RouteListener | null = null;

function matchRoute(path: string): RouteState {
  for (const route of routes) {
    const match = route.pattern.exec({ pathname: path });
    if (match) {
      return { page: route.page, params: (match.pathname.groups as Record<string, string>) ?? {} };
    }
  }
  return { page: "not-found", params: {} };
}

function dispatch() {
  if (listener) listener(matchRoute(location.pathname));
  window.dispatchEvent(new Event("url-change"));
}

export function navigate(path: string) {
  history.pushState(null, "", path);
  dispatch();
}

export function onRouteChange(fn: RouteListener) {
  listener = fn;
  window.addEventListener("popstate", dispatch);
  dispatch();
}

/** Get the current search param value. */
export function getSearchParam(key: string): string | null {
  return new URLSearchParams(location.search).get(key);
}

/** Set a search param without navigating (replaces state). */
export function setSearchParam(key: string, value: string) {
  const url = new URL(location.href);
  url.searchParams.set(key, value);
  history.replaceState(null, "", url.toString());
  window.dispatchEvent(new Event("url-change"));
}
